import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import waterfall from 'vue-waterfall2'

import 'reset-css'
import 'iview/dist/styles/iview.css';
import './assets/css/index.less'
import './assets/css/media.less'
import api from './common/api.config'
import VueLazyload from 'vue-lazyload'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);


Vue.use(waterfall)

Vue.use(iView);
Vue.use(VueLazyload);
Vue.use(Viewer);

Vue.prototype.$api = api;
Vue.config.productionTip = false

Vue.use(VueLazyload, {  
  preLoad: 1.3,                //预加载的宽高比
  error: '',     //图片加载失败时使用的图片源
  loading: '', //图片加载的路径
  attempt: 1                   //尝试加载次数
})

window.eventBus = new Vue();

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js